import React, { CSSProperties } from "react"

export const formatDate = (inputDate: Date | string) => {
	if (!inputDate) {
		return ""
	}

	if (typeof inputDate === "string") {
		inputDate = new Date(inputDate)
	}

	const time = inputDate.getTime()

	if (isNaN(time)) {
		return ""
	}

	const localISOString = new Date(time - (inputDate.getTimezoneOffset() * 60000)).toISOString()
	return localISOString.slice(0, 19)
}

export const LocalDatetime = (props: {
    style?: CSSProperties
    datetime: string
    min?: Date
    onChange?: (d: string) => void
    disabled?: boolean
}) => {
	const { style, datetime, min, onChange, disabled } = props

	return (
		<input type="datetime-local"
			style={style}
			required={Boolean(onChange) && !disabled}
			disabled={disabled}
			min={min ? formatDate(min) : undefined}
			value={formatDate(datetime)}
			onChange={onChange && !disabled ? e => {
				const date = new Date(e.target.value)

				if (isNaN(date.getTime())) {
					onChange(datetime)

					return
				}

				onChange(date.toISOString())
			} : undefined}
		/>
	)
}
